// Copyright (c) 2020 Deere & Company
import './index.scss';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';

const LabeledReactSelect = props => (
    <section className={`options-dropdown-section ${props.className}`}>

        {props.label ? (
            <label htmlFor={props.inputId} className={`options-dropdown-label ${props.isRequired ? 'form-group-title asterisk-after' : 'form-group-title optional-criteria'}`}>
                <FormattedMessage id={props.label} />
            </label>
        ) :
            null
        }
        <span className={`asterisk-icon ${props.isRequired ? 'mandatory' : ''}`}><i className="fa fa-asterisk" /></span>
        <Select
            closeMenuOnSelect={props.closeMenuOnSelect}
            maxMenuHeight={props.maxMenuHeight}
            menuPortalTarget={document.body}
            value={props.selectedValue}
            options={props.options}
            onChange={props.onChange}
            className="labeled-react-select-dropdown"
            placeholder={props.showPlaceholder && props.placeholder}
            isMulti={props.isMulti}
            disabled={props.disabled}
            isDisabled={props.disabled}
            inputId={props.inputId}
            filterOption={props.filterOption}
            isClearable={props.isClearable}
            styles={props.styles}
            isSearchable={props.isSearchable}
        />
    </section>
);
LabeledReactSelect.displayName = 'LabeledReactSelect';
LabeledReactSelect.propTypes = {
    alwaysCallOnChange: PropTypes.bool,
    className: PropTypes.string,
    isPlaceholderTranslated: PropTypes.bool.isRequired,
    isRequired: PropTypes.bool,
    isMulti: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    optionDisplayAttributes: PropTypes.arrayOf( PropTypes.string ),
    optionKey: PropTypes.string,
    options: PropTypes.arrayOf( PropTypes.object ).isRequired,
    placeholder: PropTypes.string,
    selectedValue: PropTypes.oneOfType( [PropTypes.string, PropTypes.number, PropTypes.object] ),
    showPlaceholder: PropTypes.bool,
    disabled: PropTypes.bool,
    maxMenuHeight: PropTypes.number,
    closeMenuOnSelect: PropTypes.bool,
    inputId: PropTypes.string,
    filterOption: PropTypes.func,
    isClearable: PropTypes.bool,
    styles: PropTypes.object,
    isSearchable: PropTypes.bool
};
LabeledReactSelect.defaultProps = {
    alwaysCallOnChange: false,
    showPlaceholder: true,
    isMulti: false,
    closeMenuOnSelect: true,
    isSearchable: true
};

export default LabeledReactSelect;
